<template>
  <detra-modal :sidebar="true" :show="show_modal" @hide="hide()">
    <div class="p-24 pb-0">
      <div class="heading-medium">{{ _title }}</div>
      <div class="text-large mt-16" v-if="_task_user_name && _task_date">{{ _task_user_name }}, {{ _task_date }}</div>
      <div class="text-regular mt-16" v-if="_time_left_visual">Unscheduled hours: {{ _time_left_visual }}</div>
    </div>
    <div class="divider mt-24"></div>
    <div class="dm-content">

      <div class="heading-medium">Task details</div>

      <div class="task-switches" v-if="_show_task_switches">
        <div class="button" :class="{'active': this.task.type === 'client'}" @click="setTaskType('client')">Client
          task
        </div>
        <div class="button" :class="{'active': this.task.type === 'internal'}" @click="setTaskType('internal')">Internal
          task
        </div>
      </div>

      <div>
        <div class="mt-16" v-show="task.type === 'client'">
          <div class="text-strong">Task name</div>
          <input v-model="task.name" class="form-control" type="text" placeholder="Task name">
        </div>
        <div class="mt-16" v-show="task.type === 'internal'">
          <div class="text-strong">Activity group</div>
          <v-select
            v-if="task && activity_groups"
            :disabled="!activity_groups"
            v-model="selected_activity_group"
            :options="activity_groups"
            label="name"
            :reduce="ag => ag.id"
            @blur=""
            class=""
          ></v-select>
          <div class="mt-3" v-show="task && selected_activity_group">
            <div class="text-strong">Activity</div>
            <v-select
              v-if="task && selected_activity_group"
              :disabled="!selected_activity_group"
              v-model="selected_activity"
              :options="selected_activity_group.activities"
              label="name"
              :reduce="a => a.id"
              @blur=""
            ></v-select>
          </div>
        </div>
      </div>
      <div class="mt-16 flex w-100">
        <div class="mr-24 w-33">
          <div class="text-strong">Project</div>
          <v-select
            v-show="task.type === 'client'"
            v-if="task && projects"
            :disabled="!projects"
            v-model="selected_project"
            :options="_projects_to_select"
            label="name"
            :reduce="p => p.id"
            @blur="$v.task.project_id.$touch()"
          ></v-select>
          <div v-show="task.type === 'internal'">
            <input type="text" :disabled="true" class="form-control" placeholder="Internal">
          </div>
        </div>
        <div class="mr-24 w-33">
          <div class="text-strong">Planned hours</div>
          <input v-model="duration" type="text" class="form-control" placeholder="1:00">
        </div>
        <div class="w-33">
          <div class="text-strong">Tag</div>
          <select class="form-control" v-model="task.tag_id">
            <option :value="null">optional</option>
            <option :value="tag.id" v-for="tag in tags">{{ tag.name }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="divider mt-24 mb-24"></div>
    <div class="pl-24 pr-24 pointer">
      <div v-show="!show_description" @click="toggleDescription()">
        <span class="text-large mr-16">+</span><span class="text-large">Add a description</span>
      </div>
      <div v-show="show_description">
        <div class="flex" @click="toggleDescription()">
          <div class="heading-medium w-50">Task description</div>
          <div class="heading-medium text-right w-50">-</div>
        </div>
        <div class="mt-16">
          <textarea v-model="task.description" class="form-control" rows="5" placeholder="Description"></textarea>
        </div>
      </div>
    </div>

    <div v-show="_show_assignations">
      <div class="divider mt-24 mb-24"></div>
      <assignations :duration="duration" :users="users" v-model="assignations"></assignations>
    </div>
    <div class="divider mt-24 mb-24"></div>

    <div class="mt-24 mb-24 text-center">
      <div class="btn btn-jet w-240" @click="edit ? updateTask() : createTask()">
        <span v-if="!edit">Add client task</span>
        <span v-if="edit">Update</span>
      </div>
    </div>
    <template slot="sidebar">
      <task-sidebar :task="task"></task-sidebar>
    </template>
  </detra-modal>
</template>
<script>

import TaskSidebar from './task-sidebar'
import Assignations from './assignations'

let newTask = {
  id: null,
  name: null,
  date: null,
  description: null,
  client_id: null,
  project_id: null,
  tag_id: null,
  type: 'client',
  project: {
    name: null,
  },
  client: {
    name: null,
    manager: {
      name: null,
    }
  },
  user: {
    name: null,
  },
  comments: [],
}
export default {
  components: {
    TaskSidebar,
    Assignations,
  },
  created() {

    this.loadData()

    this.$root.$on('Projects::created', project => this.loadData('projects'))

    this.$root.$on('TaskModal::create-task', ({row, col, project}) => {
      this.edit = false
      this.resetTaskData()

      //if we have col and row then task is being added from agenda
      //otherwise it will be task pool
      if (col && row) {
        this.task.date = col.date
        this.time_left = col.time_left

        this.task.user = _.find(this.users, u => u.id === row.user.id)
        this.$root.$emit('Assignations::new', {
          user_id: this.task.user.id,
          date: this.task.date,
          duration: '01:00',
          parent: true,
        })
        // this.$root.$emit('Assignations::open')

        this.modalCalledBy = 'agenda'
      }

      if (project) {
        this.selected_project = _.find(this.projects, p => p.id == project.id)
        this.task.project = project
        this.task.project_id = project.id
        this.task.client = project.client

        this.modalCalledBy = 'task-pool'
      }

      this.show()
    })
    this.$root.$on('TaskModal::edit-task', ({project, task_id, row, col}, callback) => {
      this.edit = true

      this.loadData()
      this.axios.get('/n/tasks/' + task_id).then(response => {
        let task = response.data.data
        this.task.id = task.id
        this.task.name = task.name
        this.task.activity_id = task.activity_id
        this.task.description = task.description
        this.task.date = task.date
        this.task.project_id = task.project_id
        this.task.tag_id = task.tag_id
        this.task.project = task.project
        this.selected_project = _.find(this.projects, p => p.id == task.project_id)
        this.task.client = task.client
        this.task.comments = this.parseComments(task.comments)
        this.task.user = task.user
        this.task.type = task.type
        this.duration = task.visual_duration
        this.time_left = col ? col.time_left : null

        this.preloadActivities()

        this.toggleDescription(!!this.task.description)

        this.$root.$emit('Assignations::clear')
        _.each(task.assignations, assignation => {
          this.$root.$emit('Assignations::add', {
            id: assignation.id,
            user_id: assignation.user.id,
            date: assignation.date,
            duration: assignation.duration_formatted,
            parent: assignation.parent
          })
        })

        if (project) {
          this.modalCalledBy = 'task-pool'
        }
        if (row && col) {
          this.modalCalledBy = 'agenda'
        }

        this.show()
        callback && callback()
      })
    })
  },
  data() {
    return {
      edit: false,
      show_modal: false,
      show_description: false,
      projects: null,
      clients: null,
      task: newTask,
      duration: '1:00',
      selected_project: null,
      time_left: null,
      tags: [],
      users: [],
      assignations: null,
      modalCalledBy: null,
      activity_groups: null,
      selected_activity_group: null,
      selected_activity: null,
    }
  },
  watch: {
    selected_project(project) {
      if (project) {
        this.task.project_id = project.id
      } else {
        this.task.project_id = null
      }
    },
    'task.project_id': {
      handler(value) {
        if (value == null) {
          this.task.project = null
          this.task.client = null
          this.task.client_id = null
        } else {
          let project = _.find(this.projects, p => p.id == value)
          let client = _.find(this.clients, c => c.id == project.client_id)

          this.task.project = project
          this.task.client_id = client.id
          this.task.client = client
        }
      }
    },
    duration: {
      handler(value) {
        if (!this.task.id && this.assignations.length === 1) {
          this.assignations[0].duration = value
        }
        if (this.task.id) {
          _.each(this.assignations, assignation => {
            if (assignation.id == this.task.id) {
              assignation.duration = value
            }
          })
        }
      }
    },
    assignations: {
      handler(value) {
        if (this.task.id) {
          let assignation = _.find(this.assignations, a => a.id == this.task.id)
          if (assignation) {
            this.duration = assignation.duration
          }
        }
      },
      deep: true,
    }
  },
  computed: {
    _is_parent() {
      return this.task.parent_id == null
    },
    _title() {
      if (this._is_parent && !this.edit) return 'Add new client task'
      if (this._is_parent && this.edit) return 'Edit client task'
      if (!this._is_parent && !this.edit) return 'Add task in agenda'
      if (!this._is_parent && this.edit) return 'Edit task'
    },
    _task_date() {
      //2021-01-01 (Thursday)
      return this.task.date ? moment(this.task.date).format('YYYY-MM-DD (dddd)') : null
    },
    _task_user_name() {
      return this.task.user ? this.task.user.name : null
    },
    _time_left_visual() {
      if (!this.time_left) {
        return null
      }

      return this.$root.formatIntegerSecondsToReadable(this.time_left)
    },
    _show_task_switches() {
      return true
    },
    _show_assignations() {
      return this._is_parent
    },
    _projects_to_select() {
      return _.filter(this.projects, p => !p.is_billed)
    }
  },
  methods: {
    show() {
      this.show_modal = true
    },
    hide() {
      this.show_modal = false
    },
    createTask() {
      let data = {
        task: {
          name: this.task.type === 'client' ? this.task.name : this.selected_activity.name,
          activity_id: this.selected_activity ? this.selected_activity.id : null,
          date: this.task.date,
          description: this.task.description,
          client_id: this.task.client_id,
          project_id: this.task.project_id,
          user_id: this.task.user.id,
          type: this.task.type,
          tag_id: this.task.tag_id,
        },
        duration: this.duration,
        assignations: this.assignations,
      }

      this.axios.post('/n/tasks', data).then(response => {
        let tasks = response.data.data
        _.each(tasks, task => {
          this.$root.$emit('Tasks::created', {task})
        })
        this.hide()
      }).catch(err => {
        console.log(err)
      })
    },
    updateTask() {
      let data = {
        task: {
          name: this.task.type === 'client' ? this.task.name : this.selected_activity.name,
          activity_id: this.selected_activity ? this.selected_activity.id : null,
          date: this.task.date,
          description: this.task.description,
          client_id: this.task.client_id,
          project_id: this.task.project_id,
          user_id: this.task.user ? this.task.user.id : null,
          type: this.task.type,
          tag_id: this.task.tag_id,
        },
        duration: this.duration,
        assignations: this.assignations,
      }

      this.axios.put('/n/tasks/' + this.task.id, data).then(response => {
        let created = response.data.newTasks
        let updated = response.data.updatedTasks
        let deleted = response.data.deletedTasks
        _.each(created, task => this.$root.$emit('Tasks::created', {task}))
        _.each(updated, task => this.$root.$emit('Tasks::updated', {task}))
        _.each(deleted, task => this.$root.$emit('Tasks::deleted', {task}))
        this.hide()
      }).catch(err => {
        console.log(err)
      })
    },
    setTaskType(type) {
      this.task.type = type

      this.selected_activity = null
      this.selected_activity_group = null

      if (type === 'internal') {
        this.loadData('activity_groups')
      }
    },
    parseComments(comments) {
      let result = []
      _.each(comments, comment => {
        result.push(comment)
      })

      return result
    },
    toggleDescription(show = null) {
      if (show !== null) {
        this.show_description = show
      } else {
        this.show_description = !this.show_description
      }
    },
    resetTaskData() {
      this.time_left = null
      this.task.id = null
      this.task.name = null
      this.task.activity_id = null
      this.task.description = null
      this.task.client_id = null
      this.task.project_id = null
      this.task.tag_id = null
      this.task.project = {
        name: null,
      }
      this.task.client = {
        name: null,
        manager: {
          name: null,
        }
      }
      this.task.user = {
        name: null,
      }
      this.task.comments = []
      this.task.type = 'client'
      this.duration = '1:00'
      this.selected_project = null
      this.$root.$emit('Assignations::clear')
      this.$root.$emit('Assignations::close')

      this.selected_activity = null
      this.selected_activity_group = null
    },
    loadData(r = 'all') {
      if (r == 'all' || r == 'tags') {
        this.axios.get('/n/tags').then(response => {
          this.tags = response.data.data
        })
      }
      if (r == 'all' || r == 'projects') {
        this.axios.get('/n/projects?&notBilled=true&simple=true').then(response => {
          this.projects = response.data.data
        })
      }
      if (r == 'all' || r == 'clients') {
        this.axios.get('clients?with=manager').then(response => {
          this.clients = response.data.data
        })
      }
      if (r == 'all' || r == 'users') {
        this.axios.get('users?task-modal=true').then(response => {
          this.users = response.data.data
        })
      }
      if (r == 'all' || r == 'activity_groups') {
        this.axios.get('/n/activity-groups').then(response => {
          this.activity_groups = response.data.data
          this.preloadActivities()
        })
      }
    },
    preloadActivities() {
      // preselect activity groups if needed
      if (this.task.activity_id) {
        _.each(this.activity_groups, ag => {
          _.each(ag.activities, activity => {
            if (activity.id === this.task.activity_id) {
              this.selected_activity_group = ag
              this.selected_activity = activity
            }
          })
        })
      }
    }
  }
}
</script>
<style lang="scss">
.task-switches {
  margin-top: 16px;
  display: flex;
  flex-basis: 0;
  color: #4D4D4D;
  background: #FAFAFA;
  width: max-content;

  .button {
    padding: 10px 28px;
    cursor: pointer;
    border: 1px solid #D5D5D5;
    display: flex;
    align-items: center;

    &:first-child {
      border-radius: 4px 0 0 4px;
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }

    &.active {
      background: #FFF3E9;
      border: 2px solid #FF7800;

      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      color: #2F2F2F;
    }
  }
}

.deadline {
  display: flex;

  .heading-small {
    flex-grow: 1;
    text-align: right;
  }
}

.comments {
  padding: 24px;

  .comment {
    background: white;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #D5D5D5;
    margin-top: 8px;

    .heading {
      color: #999999;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 130%;
      margin-bottom: 4px;
    }
  }
}

.assignations-table {
  width: 100%;

  td, th {
    padding-right: 12px;
    padding-left: 12px;
    padding-bottom: 4px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-modal/task-modal.vue